import { render, staticRenderFns } from "./BatchFileUploadTableModal.vue?vue&type=template&id=5863ec4f&scoped=true"
import script from "./BatchFileUploadTableModal.vue?vue&type=script&lang=js"
export * from "./BatchFileUploadTableModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5863ec4f",
  null
  
)

export default component.exports